import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import {
  Equipment,
  EquipmentApi,
  GetPatientDiagnosisRendered,
  Medication,
  MedicationApi,
  PatientTreatmentsApi,
} from "../../../api/medical-operations";
import { configState } from "../../../recoil/atoms";
import MainCard from "../../../styles/ui-component/cards/MainCard";
import TreatmentForm from "./TreatmentForm";
import { Card, CardActionArea, CardContent, Divider, Grid, Typography } from "@mui/material";
import useStyles from "../../../styles/styles";
import { validationSchema } from "./FormModel/validationSchema";
import { toast } from "react-toastify";

type Props = {
  patientDiagnosis?: GetPatientDiagnosisRendered;
};

export const AddPatientTreatments = ({ patientDiagnosis }: Props) => {
  const config = useRecoilValue(configState);
  const classes = useStyles();

  const [equipment, setEquipment] = useState<Equipment[]>([]);
  const [medications, setMedications] = useState<Medication[]>([]);
  const [type, setType] = useState<string>();

  const addPatientTreatment = (values: any, actions: any) => {
    const patientTreatment = new PatientTreatmentsApi(config);
    patientTreatment
      .createPatientTreatment(values)
      .then((res) => {
        toast.success(res?.data?.Message!);
        actions.resetForm({});
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  const submitForm = (values: any, actions: any) => {
    actions.setSubmitting(false);
    addPatientTreatment(
      {
        ...values,
        AppointmentID: patientDiagnosis![1],
        PatientDiagnosisID: patientDiagnosis![0],
        Type: type,
      },
      actions
    );
  };

  const getMedications = () => {
    const medication = new MedicationApi(config);
    medication
      .getMedication()
      .then((res) => {
        setMedications(res?.data);
      })
      .catch((err) => {
            toast.error(err?.response?.data?.detail);
      });
  };

  const getEquipment = () => {
    const Equipment = new EquipmentApi(config);
    Equipment.getEquipment()
      .then((res) => {
        setEquipment(res?.data);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  useEffect(() => {
    getEquipment();
    getMedications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <MainCard>
        <Typography variant="h3" gutterBottom sx={{ p: 2 }}>
          Add Patient Treatment
        </Typography>
        <Divider />

        <Grid container spacing={2} direction="row" alignItems="center" justifyContent="center" sx={{ mt: 5 }}>
          <Typography variant="h4" gutterBottom sx={{ p: 0 }}>
            Please choose type of patient treatment:
          </Typography>
          <Grid container />
          <Grid item xs={6} md={2}>
            <Card>
              <CardActionArea
                href=""
                style={{ display: "flex", justifyContent: "center", border: "ridge" }}
                className={type === "Equipment" ? classes.pressedButton : undefined}
                onClick={() => {
                  setType("Equipment");
                }}
              >
                <CardContent>
                  <Typography>Equipment </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
          <Grid item xs={6} md={2}>
            <Card>
              <CardActionArea
                href=""
                style={{ display: "flex", justifyContent: "center", border: "ridge" }}
                className={type === "Medication" ? classes.pressedButton : undefined}
                onClick={() => {
                  setType("Medication");
                }}
              >
                <CardContent>
                  <Typography>Medication </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        </Grid>
        {type === "Equipment" && (
          <Formik
            initialValues={{ Equipment: { StartDate: "", EndDate: "" } }}
            enableReinitialize={true}
            validationSchema={validationSchema[0]}
            onSubmit={submitForm}
          >
            {({ dirty }) => (
              <Form>
                <TreatmentForm equipment={equipment} type={type} setType={setType} />
              </Form>
            )}
          </Formik>
        )}
        {type === "Medication" && (
          <Formik
            initialValues={{ Medication: { StartDate: "", EndDate: "" } }}
            enableReinitialize={true}
            validationSchema={validationSchema[1]}
            onSubmit={submitForm}
          >
            {({ dirty }) => (
              <Form>
                <TreatmentForm medications={medications} type={type} setType={setType} />
              </Form>
            )}
          </Formik>
        )}
      </MainCard>
    </>
  );
};
